import { createApiService } from "@/core/api/apiService";
import type { NotificationDto } from "../types/notificationTypes";

export function createNotificationApiClient(businessId: string) {
  const api = createApiService(`businesses/${businessId}/notifications`);

  return {
    getAll: async (unreadOnly?: boolean, signal?: AbortSignal): Promise<NotificationDto[]> => {
      const query = unreadOnly ? "?unreadOnly=true" : "";
      return api.get<NotificationDto[]>(`/${query}`, { signal });
    },

    markAsRead: async (id: string): Promise<NotificationDto> => {
      return api.post<NotificationDto>(`/${id}/read`, {});
    },

    markAllAsRead: async (): Promise<{ message: string }> => {
      return api.post<{ message: string }>("/read-all", {});
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}

export const notificationApiService = {
  forBusiness: createNotificationApiClient,
};
